import PageRoute from "components/PageRoute/PageRoute";
import React from "react";
import { RouteObject } from "react-router-dom";

const ProfileModule = React.lazy(() => import("./ProfileModule"));

export const ProfileModuleRoutes: RouteObject = {
  path: "account",
  element: <PageRoute El={ProfileModule} />,
};
